import React from 'react';
import styles from './Category.module.css';
import { Link } from 'react-router-dom';
import { FiArrowLeftCircle, FiArrowRightCircle } from "react-icons/fi";
import Header from '../../components/Header/Header';

export default class Category extends React.Component {

    constructor(props) {
        super(props);

        this.categoryID = this.props.match.params.categoryID || 14;

        this.categoryWeekList = {
            // categoryID: [ [categoryWeekID, weekNum, title]]
            '14': [
                ['1','1','Introduction to Biology & The Scientific Method'],
                ['2','2','Chemistry of Life'],
                ['3','3','Cell Structure and Function'],
                ['4','4','Energy and Metabolism'],
                ['5','5','Cell Division and Genetics Basics'],
                ['6','6','Molecular Biology Fundamentals'],
                ['7','7','Evolution and Natural Selection'],
                ['8','8','Diversity of Life'],
                ['9','9','Ecology Basics'],
                ['10','10','Integration & Review'],
            ],
            
            '15': [
                ['11','1','Introduction to Cells & Microscopy'],
                ['12','2','Prokaryotic vs. Eukaryotic Cells'],
                ['13','3','Cell Membranes & Transport'],
                ['14','4','Organelles and Intracellular Compartments'],
                ['15','5','Cytoskeleton & Cell Motility'],
                ['16','6','Cell Signaling & Communication'],
                ['17','7','The Cell Cycle & Cell Division'],
                ['18','8','Apoptosis and Cell Death'],
                ['19','9','Stem Cells & Cellular Differentiation'],
                ['20','10','Integration & Laboratory Applications'],
            ],

            '16': [
                ['21','1','Introduction to Molecular Biology'],
                ['22','2','DNA Structure and Function'],
                ['23','3','DNA Replication'],
                ['24','4','RNA and Transcription'],
                ['25','5','Translation and Protein Synthesis'],
                ['26','6','Gene Regulation'],
                ['27','7','Molecular Techniques I'],
                ['28','8','Molecular Techniques II'],
                ['29','9','Signal Transduction and Molecular Pathways'],
                ['30','10','Integration & Applications'],
            ],
            
            '17': [
                ['31','1','Introduction to Genetics'],
                ['32','2','Mendelian Genetics'],
                ['33','3','Extensions of Mendelian Genetics'],
                ['34','4','Chromosomes and Karyotypes'],
                ['35','5','Molecular Basis of Inheritance'],
                ['36','6','Population Genetics'],
                ['37','7','Linkage and Mapping'],
                ['38','8','Epigenetics and Regulation'],
                ['39','9','Genetic Technologies'],
                ['40','10','Integration & Applications'],
            ],

            
            '18': [
                ['41','1','Introduction to Ecology'],
                ['42','2','Population Ecology I'],
                ['43','3','Population Ecology II'],
                ['44','4','Community Ecology I'],
                ['45','5','Community Ecology II'],
                ['46','6','Ecosystem Ecology I'],
                ['47','7','Ecosystem Ecology II'],
                ['48','8','Behavioral Ecology'],
                ['49','9','Conservation Ecology'],
                ['50','10','Integration & Field Applications'],
            ],
            
            '19': [
                ['51','1','Introduction to Evolution'],
                ['52','2','Mechanisms of Evolution I'],
                ['53','3','Mechanisms of Evolution II'],
                ['54','4','Speciation and Reproductive Isolation'],
                ['55','5','Phylogenetics and Evolutionary Trees'],
                ['56','6','Comparative Anatomy and Development'],
                ['57','7','Molecular Evolution'],
                ['58','8','Coevolution and Adaptive Radiations'],
                ['59','9','Evolution in Populations'],
                ['60','10','Integration & Applications'],
            ],
            
            '20': [
                ['61','1','Introduction to Microbiology'],
                ['62','2','Microscopy and Microbial Techniques'],
                ['63','3','Microbial Cell Structure'],
                ['64','4','Microbial Metabolism'],
                ['65','5','Microbial Genetics'],
                ['66','6','Microbial Growth and Control'],
                ['67','7','Immunology Basics'],
                ['68','8','Microbial Ecology'],
                ['69','9','Applied Microbiology'],
                ['70','10','Integration & Laboratory Applications'],
            ],
            
            '21': [
                ['71','1','Introduction to Plant Biology'],
                ['72','2','Plant Cell Structure and Function'],
                ['73','3','Plant Anatomy and Morphology'],
                ['74','4','Plant Physiology I – Photosynthesis & Respiration'],
                ['75','5','Plant Physiology II – Water, Nutrients, and Transport'],
                ['76','6','Plant Reproduction'],
                ['77','7','Plant Development and Hormones'],
                ['78','8','Plant Ecology and Adaptations'],
                ['79','9','Economic and Medicinal Plants'],
                ['80','10','Integration & Laboratory/Field Applications'],
            ],
            
            '22': [
                ['81','1','Introduction to Zoology'],
                ['82','2','Animal Cell and Tissue Structure'],
                ['83','3','Invertebrate Diversity'],
                ['84','4','Vertebrate Diversity'],
                ['85','5','Animal Physiology I – Homeostasis & Circulation'],
                ['86','6','Animal Physiology II – Respiration & Digestion'],
                ['87','7','Nervous and Endocrine Systems'],
                ['88','8','Reproduction and Development'],
                ['89','9','Behavior and Ecology'],
                ['90','10','Integration & Case Studies'],
            ],
            
            '23': [
                ['91','1','Introduction to Physiology & Homeostasis'],
                ['92','2','Cell Physiology'],
                ['93','3','Nervous System I'],
                ['94','4','Nervous System II & Sensory Systems'],
                ['95','5','Endocrine System'],
                ['96','6','Circulatory System'],
                ['97','7','Respiratory & Digestive Systems'],
                ['98','8','Musculoskeletal System'],
                ['99','9','Excretory & Immune Systems'],
                ['100','10','Integration & Applied Physiology'],
            ],
            
            '24': [
                ['101','1','Introduction to Developmental Biology'],
                ['102','2','Fertilization and Early Embryogenesis'],
                ['103','3','Gastrulation'],
                ['104','4','Organogenesis I – Early Organ Formation'],
                ['105','5','Organogenesis II – Later Organ Development'],
                ['106','6','Stem Cells and Differentiation'],
                ['107','7','Developmental Genetics'],
                ['108','8','Signaling Pathways in Development'],
                ['109','9','Regeneration and Aging'],
                ['110','10','Integration & Laboratory Applications'],
            ],
            
            '25': [
                ['111','1','Introduction to Biological Laboratory Practices'],
                ['112','2','Microscopy Techniques'],
                ['113','3','Spectroscopy and Centrifugation'],
                ['114','4','Molecular Biology Techniques I'],
                ['115','5','Molecular Biology Techniques II'],
                ['116','6','Cell Culture Techniques'],
                ['117','7','Enzyme and Biochemical Assays'],
                ['118','8','Imaging and Labeling Techniques'],
                ['119','9','Experimental Design and Data Analysis'],
                ['120','10','Integration & Lab Projects'],
            ],
            
            '26': [
                ['121','1','Introduction to Field Biology'],
                ['122','2','Observation and Data Recording'],
                ['123','3','Sampling Techniques I – Plants'],
                ['124','4','Sampling Techniques II – Animals'],
                ['125','5','Ecosystem and Habitat Surveys'],
                ['126','6','Population Monitoring and Dynamics'],
                ['127','7','Biodiversity Assessment'],
                ['128','8','Ecological Interactions'],
                ['129','9','Conservation Fieldwork'],
                ['130','10','Integration & Field Project'],
            ],
            
            '27': [
                ['131','1','Introduction to Biological Research'],
                ['132','2','Literature Review and Hypothesis Formation'],
                ['133','3','Experimental Design I'],
                ['134','4','Experimental Design II'],
                ['135','5','Data Collection Techniques'],
                ['136','6','Statistical Analysis I'],
                ['137','7','Statistical Analysis II'],
                ['138','8','Scientific Writing and Communication'],
                ['139','9','Grant Writing and Proposal Development'],
                ['140','10','Integration & Independent Research Project'],
            ],
            
            '28': [
                ['141','1','Project Introduction & Topic Selection'],
                ['142','2','Proposal Development'],
                ['143','3','Experimental or Field Preparation'],
                ['144','4','Data Collection I'],
                ['145','5','Data Collection II'],
                ['146','6','Data Analysis I'],
                ['147','7','Data Analysis II'],
                ['148','8','Discussion and Interpretation'],
                ['149','9','Writing the Final Report'],
                ['150','10','Presentation & Peer Review'],
            ],
        };


        this.categoryList = {
            '14': 'General Biology',
            '15': 'Cell Biology',
            '16': 'Molecular Biology',
            '17': 'Genetics',
            '18': 'Ecology',
            '19': 'Evolutionary Biology',
            '20': 'Microbiology',
            '21': 'Plant Biology / Botany',
            '22': 'Animal Biology / Zoology',
            '23': 'Physiology',
            '24': 'Developmental Biology',
            '25': 'Laboratory Techniques in Biology',
            '26': 'Field Studies in Biology',
            '27': 'Research Methods in Biology',
            '28': 'Capstone Biology Project',
        };

    };

    componentDidMount() {
    };
    
    iOS = () => {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    };

    render() {
        return (
            <div className={styles.rootView}>
                {/* <img src={require('../../assets/animation.gif')} className={styles.background} /> */}
                <div className={styles.background} />

                <Header />

                <div className={styles.content}>
                    {/* <div className={styles.logoView}>
                        <img className={styles.logoImage} src={require('../../assets/logo.png')} />
                    </div> */}

                    <div
                        className={styles.backButtonView}
                        onClick={() => window.history.back()}
                    >
                        <FiArrowLeftCircle color='#032d7388' />
                        <div>Back</div>
                    </div>

                    <div className={styles.title}>
                        {this.categoryList[this.categoryID]}
                    </div>

                    <div className={styles.subtitle}>
                        Pick a subcategory to begin a quiz!
                    </div>

                    {/* <div className={styles.subtitle}>
                        Make quizzes from your
                        <div className={styles.subtitleBold}>notes, and books!</div>
                    </div> */}

                    {/* <a href={this.appLink}>
                        <img src={require('../../assets/appstore.png')} className={styles.appstore} />
                    </a> */}

                    {
                        this.categoryWeekList[this.categoryID].map(item => {
                            const categoryWeekID = item[0];
                            const weekNum = item[1];
                            const title = item[2];
                            return (
                                <a key={`studyItem_${categoryWeekID}`} href={`/categoryWeek/${categoryWeekID}/0/${title}`}>
                                    <div className={styles.studyItem}>
                                        <div>{title}</div>
                                        <FiArrowRightCircle color='#032d73' />
                                    </div>
                                </a>
                            )
                        })
                    }

                    <div className={styles.footer}>
                        {/* <a href='mailto:vibegameapp@gmail.com' className={styles.link}>Help</a> */}
                        {/* <Link to="/help" className={styles.link}>Help</Link> */}
                        <Link to="/terms" className={styles.link}>Terms</Link>
                        <Link to="/privacy" className={styles.link}>Privacy</Link>
                    </div>
                    <div className={styles.copyright}>© KVK LLC. 2025</div>
                </div>
            </div>
        );
    };
};